'use client';

import React from 'react';
import UpcomingFixtureCard from './UpcomingFixtureCard';

const FixturesContent = () => {
  const fixtures = [
    {
      id: 1,
      title: 'Colmworth',
      date: 'Saturday, 10 January 2026',
      teeTime: '09:20',
      location: 'Colmworth',
      venue: 'Bedford',
      description: 'Colmworth Golf Club booked for Saturday 10th. Tee time 09:20 meet at 08:30. Cost is £45 per player (Members Only). Break Down: Round £41 + Prize Money £3 = 2s £1',
      price: 45,
      status: 'full' as const,
      badge: 'Stableford'
    },
    {
      id: 2,
      title: 'Captains Weekend',
      date: 'Saturday, 5 September 2026',
      teeTime: '12:33',
      location: 'Cotswold Hotel & Spa',
      venue: '',
      description: 'Itinerary Saturday 5th September First Tee: 12:33pm Competitions: Nearest the pin in 2 + 1, nearest the pin + 4 Prizes: 1st, 2nd & 3rd place. Evening: 2-course Buffet with 4 bottles of wine Sunday 6th September Breakfast: 09:00am Competitions: Nearest the pin in 2 + 1, nearest the pin + 4 Prizes: 1st, 2nd & 3rd place, plus overall winner Costs £210.00 per person (based on two sharing) £210.00 single room (includes £60.00 supplement) I\'ll require a £40.00 deposit to secure your place by 31st August 2026. Buggies I can reserve buggies at £30.00, payable directly to the pro shop on the day.',
      price: 210,
      status: 'available' as const,
      availableSpaces: 16,
      badge: 'Stableford'
    }
  ];

  return (
    <section data-component-id="src/app/fixtures/components/FixturesContent.tsx:36:4" data-component-path="src/app/fixtures/components/FixturesContent.tsx" data-component-line="36" data-component-end-line="44" data-component-file="FixturesContent.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22bg-gray-50%20py-12%22%7D" className="bg-gray-50 py-12">
      <div data-component-id="src/app/fixtures/components/FixturesContent.tsx:37:6" data-component-path="src/app/fixtures/components/FixturesContent.tsx" data-component-line="37" data-component-end-line="43" data-component-file="FixturesContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-id="src/app/fixtures/components/FixturesContent.tsx:38:8" data-component-path="src/app/fixtures/components/FixturesContent.tsx" data-component-line="38" data-component-end-line="42" data-component-file="FixturesContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-6%22%7D" className="space-y-6">
          {fixtures.map((fixture) => (
            <UpcomingFixtureCard data-component-id="src/app/fixtures/components/FixturesContent.tsx:40:12" data-component-path="src/app/fixtures/components/FixturesContent.tsx" data-component-line="40" data-component-end-line="40" data-component-file="FixturesContent.tsx" data-component-name="UpcomingFixtureCard" data-component-content="%7B%22elementName%22%3A%22UpcomingFixtureCard%22%7D" key={fixture.id} fixture={fixture} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FixturesContent;